/**
 * @voltxampere/web — `<vxa-modal-root>` portal stub (Sprint 11).
 *
 * Placeholder for arbitrary modal teleportation (confirmation
 * dialogs, parameter editors, …). Sprint 13+ will implement
 * a stack-based portal API; for Sprint 11 it is empty so the
 * component tree is complete and `<vxa-app>` does not need to
 * grow when modals start landing.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("vxa-modal-root")
export class VxaModalRoot extends LitElement {
  static override styles = css`
    :host {
      display: contents;
    }
  `;

  override render() {
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "vxa-modal-root": VxaModalRoot;
  }
}
